import { useMemo } from "react";
import { Submission } from "@/bryntum-lib/models/Submission";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { useSwivuStore } from "@/react/hooks/useSwivuStore";
import { STORE_KEYS } from "@/other/constants/StoreKeys.jsx";

export function useSubmissions() {
  const { project } = useSwivuBryntumContext();

  const { version } = useSwivuStore({ storeId: STORE_KEYS.submissionsStore });

  const submissions = useMemo<Submission[]>(() => {
    if (!project) return [];
    const store = project.getCrudStore(STORE_KEYS.submissionsStore);
    if (!store) return [];
    const rows = store.query(() => true) as unknown as Submission[];
    return [...rows].sort((a, b) => {
      const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return tb - ta;
    });
  }, [project, version]);

  return { submissions };
}
